<form [formGroup]="behandelKostenFg">
    <div formArrayName="behandelKosten">
        <div *ngFor="let item of behandelKosten.controls; let i = index;"
             [formGroupName]="i" class="row">

            <snelstart-ui-text-form-control [label]="i === 0 ? 'Behandelkosten' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving">
                (change)="saveForm()"
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              [required]=true
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedrag"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijBehandelkosten(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
        </div>
    </div>
</form>

<div *ngIf="behandelKosten.length === 0">
    <snelstart-ui-button (click)="addRijBehandelkosten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Behandelkosten
    </snelstart-ui-button>
</div>
<div *ngIf="behandelKosten.length > 0">
    <snelstart-ui-button (click)="addRijBehandelkosten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Behandelkosten toevoegen
    </snelstart-ui-button>
</div>



